import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Atributo } from '../models/atributo';
import { PessoaService } from '../pessoa.service';

@Component({
  selector: 'app-atributo',
  templateUrl: './atributo.component.html',
  styleUrls: ['./atributo.component.scss']
})
export class AtributoComponent implements OnInit {

  constructor(private pessoaService: PessoaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  atributos: Atributo[];
  public idAtributo: number;
  public atributo: Atributo;
  
  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;


  ngOnInit(): void {

    this.getAtributos();
  }

  getAtributos() {
    this.pessoaService.getAtributos().subscribe(
      (res) => {
        if (res) {
          this.atributos = res;  
          console.log(this.atributos);
        }
      },
      err => {
        console.log("Atributos");
        console.log(err);
      }
    );
  } 



  addAtributo() {
    this.atributo = {};
    this.submitted = false;
    this.displayDialog = true;
  } 
  
  updAtributo(atributo: Atributo) {      
    this.atributo = {...atributo};
    this.displayDialog = true;
  }
  
  delAtributo(atributo: Atributo) {
      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja remover o atributo: ' + atributo.nome + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.pessoaService
              .delAtributo(atributo.idAtributo)
              .subscribe(                     
                  () => {this.getAtributos()
                    this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Atributo removido com sucesso!', life: 3000});
                  },
                  err => console.log(err)
              );
              
          }
      });
  }
  
  hideDialog() {
    this.atributo = {};
    this.submitted = false;
    this.displayDialog = true;        
  }
  





  saveAtributo(){
    this.submitted = true;      
    if (this.atributo.nome.trim()) {
        if (this.atributo.idAtributo) {
          
          this.pessoaService
          .updAtributo(this.atributo)
          .subscribe(                     
              () => {
                this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Atributo atualizado com sucesso!', life: 3000});
                this.getAtributos()
              },
              err => console.log(err)
          );
           
        } else {
           this.pessoaService
               .addAtributo(this.atributo)
               .subscribe(                     
                   () =>{
                    this.getAtributos()
                    this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Atributo criado com sucesso!', life: 3000});
                   }, 
                   err => 
                   {
                      this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                     console.log(err)
                   }
               );

            
        }

        this.atributos = [...this.atributos];
        this.displayDialog = false;
        this.atributo = {};
    }
  }


}
